import { combineReducers } from "redux";

import cart from "./cart";
import addresses from "./addresses";
import rfq from "./rfq";

export default combineReducers({ cart, addresses, rfq });
